import type { WizardFarm } from '../../types/farmWizard'

import { getActiveTenantKey, getTenantScopedKey } from '../tenant'
import { saveJSON } from '../../utils/storage'

const FARM_LIST_KEY = 'farms'

const hasStorage = (): boolean => typeof window !== 'undefined' && Boolean(window.localStorage)

const clone = <T>(value: T): T => structuredClone(value)

const normalizeFarm = (candidate: any): WizardFarm | null => {
  if (!candidate || typeof candidate !== 'object') return null
  if (typeof candidate.id !== 'string' || candidate.id.trim().length === 0) return null
  if (typeof candidate.name !== 'string' || candidate.name.trim().length === 0) return null

  const productionUnits = Array.isArray(candidate.productionUnits)
    ? candidate.productionUnits.filter((unit: any) => unit && typeof unit === 'object' && typeof unit.id === 'string' && typeof unit.name === 'string')
    : []

  return {
    ...clone(candidate),
    id: candidate.id,
    name: candidate.name,
    productionUnits
  } as WizardFarm
}

export const readFarmsFromLocalStorage = (tenantKey = getActiveTenantKey()): WizardFarm[] => {
  if (!hasStorage()) return []
  try {
    const scopedKey = getTenantScopedKey(FARM_LIST_KEY, tenantKey)
    const raw = window.localStorage.getItem(scopedKey)
      ?? (tenantKey === 'default' ? window.localStorage.getItem(FARM_LIST_KEY) : null)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.map(normalizeFarm).filter((farm): farm is WizardFarm => Boolean(farm))
  } catch {
    return []
  }
}

export const writeFarmsToLocalStorage = (farms: WizardFarm[], tenantKey = getActiveTenantKey()): void => {
  if (!hasStorage()) return
  const scopedKey = getTenantScopedKey(FARM_LIST_KEY, tenantKey)
  saveJSON(scopedKey, farms.map((farm) => clone(farm)))
}
